import firebase from 'firebase/app';

// Optionally import the services that you want to use
import "firebase/auth";
import "firebase/database";
//import "firebase/firestore";
//import "firebase/functions";
//import "firebase/storage";

// Initialize Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDbAwUx--JuqhbIth3_jwS8ayTrNoF9bPU",
  authDomain: "sasamenu-1568b.firebaseapp.com",
  databaseURL: "https://sasamenu-1568b-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "sasamenu-1568b",
  storageBucket: "sasamenu-1568b.appspot.com",
  messagingSenderId: "603605108465",
  appId: "1:603605108465:web:7d036c1d2b4058ce504b50",
  measurementId: "G-43K1LQF7KR"
};

firebase.initializeApp(firebaseConfig)



export default firebase;